import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner"]

  connect() {
    this.showLoadingBound = this.showLoading.bind(this)
    this.hideLoadingBound = this.hideLoading.bind(this)

    document.addEventListener("turbo:visit", this.showLoadingBound)
    document.addEventListener("turbo:before-render", this.hideLoadingBound)
    document.addEventListener("turbo:load", this.hideLoadingBound)
    document.addEventListener("turbo:fetch-request-error", this.hideLoadingBound)
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this.showLoadingBound)
    document.removeEventListener("turbo:before-render", this.hideLoadingBound)
    document.removeEventListener("turbo:load", this.hideLoadingBound)
    document.removeEventListener("turbo:fetch-request-error", this.hideLoadingBound)
  }

  showLoading() {
    this.spinnerTarget.classList.remove("hidden")
  }

  hideLoading() {
    this.spinnerTarget.classList.add("hidden")
  }
}
